import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { CartLine } from 'src/models/DTO/cart/cartLine';
import { CreatedOrder } from 'src/models/DTO/orders/createdOrder';
import { Organisation } from 'src/models/DTO/organisation/organisation';
import { Partner } from 'src/models/DTO/partners/partner';
import { CreateOrderReturnRequestModel } from 'src/models/requestModels/orders/CreateOrderReturnRequestModel';
import { Return } from 'src/models/requestModels/returns/return';
import { OrderService } from 'src/services/request/orders/order.service';
import { PartnerService } from 'src/services/request/partner/partner.service';
import { OrderReturnServiceService } from 'src/services/request/returns/order-return-service.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { ReturnService } from 'src/services/state/return/return.service';

@Component({
  selector: 'app-return-info',
  templateUrl: './return-info.component.html',
  styleUrls: ['./return-info.component.css']
})
export class ReturnInfoComponent extends HistoryBaseComponent implements OnInit {


  private _oderUUID = '';
  private _cartLineUUID = '';
  private _returnInfo?: Return;
  private _partner?: Organisation;
  private _order?: CreatedOrder;
  private _cartLineSelected?: CartLine;


  constructor(
    private returnState: ReturnService,
    private activatedRoute: ActivatedRoute,
    private returnService: OrderReturnServiceService,
    private router: Router,
    private partnerService: PartnerService,
    private orderService: OrderService,
    protected location: Location,
    protected historyService: HistoryService,
  ) { 
    super(location, historyService);
    this.returnState.returnInfo$.subscribe(returnInfo => {
      this._returnInfo = returnInfo
    })
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this._oderUUID = params.orderUUID;
      this._cartLineUUID = params.cartLineUUID;
      this.loadOrder();
    })
  }

  private loadOrder() {
    this.orderService.getOrder(this._oderUUID).subscribe(createdOrder => {
      this._order = createdOrder;
      this.selectReturnedCart();
    })
  }

  private loadPartner() {
    this.partnerService.getPartnerInfo(this._cartLineSelected!.sku.product.organisation.uuid).subscribe(partner => {
      this._partner = partner;
    })
  }

  private selectReturnedCart() {
    this._cartLineSelected = this._order?.data.lines[0];
    this.loadPartner();
  }


  get organisation() {
    return this._partner;
  }

  get streetInfo() {
    if (!this._partner?.data) return '';
    let streetInfo = '';
    streetInfo += this._partner.data.return_address.street_name;
    if (this._partner.data.return_address.street_number) {
      streetInfo += (' ' + this._partner.data.return_address.street_number + ', ');
    }
    if (this._partner.data.return_address.district) {
      streetInfo += this._partner.data.return_address.district;
    }
    if (this._partner.data.return_address.address_line_2) {
      streetInfo += (' ' + this._partner.data.return_address.address_line_2);
    }
    return streetInfo;
  }

  finishReturn() {
    let returnRequestModel: CreateOrderReturnRequestModel = {
      lines: [],
      reason: this._returnInfo!.reason,
      bank_name: this._returnInfo!.bank,
      iban: this._returnInfo!.iban,
      account_owner: this._returnInfo!.name
    }
    Object.keys(this._returnInfo!.cartLines).forEach(key => {
      returnRequestModel.lines.push({
        uuid: key,
        quantity: this._returnInfo!.cartLines[key].length
      })
    })
    this.returnService.createOrderReturn(this._oderUUID, returnRequestModel).subscribe(returned => {
      this.router.navigate(['return/completed'])
    })
  }
}
